<template>
  <div class="body">
    <div class="search-box">
      <div>
        <span class="title">姓名/手机号/身份证/学号：</span>
        <el-input
          class="search-input"
          v-model="searchData"
          placeholder="请输入姓名/手机号/身份证/学号"
          clearable
          @change="getData"
        ></el-input>
      </div>
      <div style="margin-left: 16px">
        <span class="title">函授站点：</span>
        <el-select
          @change="getData"
          class="search-input"
          filterable
          clearable
          v-model="station"
          placeholder="请选择函授站点"
        >
          <el-option
            v-for="item in stations"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          > </el-option>
        </el-select>
      </div>
      <div class='margin-left-30'>
        <el-button
          class="primary-btn"
          @click="reset()"
        >重置</el-button>
        <el-button
          type="primary"
          style="margin-left: 16px"
          @click="getData()"
        >查询</el-button>
      </div>
    </div>

    <div class="container">
      <div class="tab-box">
        <!--				<div class="tab" style="margin-left: 0px">{{grade}}</div>-->
        <div class='tab-warp'>
          <div class='title'>专业:</div>
          <div class="tab">{{majorName}}</div>
        </div>
        <div class='tab-warp'>
          <div class='title'>学期:</div>
          <div class="tab">{{semesterName}}</div>
        </div>
        <el-button
          type="primary"
          @click="exportStuScore()"
        >导出学生成绩</el-button>
        <el-button
          type="primary"
          @click="showProgress"
        >查看进度</el-button>
        <!-- <el-button
        
          type="primary"
          @click="batch"
        >批量修改学生成绩</el-button> -->
      </div>

      <div class="table-cls">
        <el-table
          :data="tableData"
          :span-method='spanMethod'
          class="table"
          border
          :cell-style="{color:'#666666',fontSize:'14px'}"
          :header-cell-style="{background:'#eef1f6',color:'#333333',height:'49px',fontWeight:500,fontSize:'14px'}"
        >
          <el-table-column
            prop="name"
            align="center"
            label="姓名"
          ></el-table-column>
          <el-table-column
            prop="phone"
            align='center'
            label="手机号"
          ></el-table-column>
          <el-table-column
            prop="id_card"
            align='center'
            label="身份证"
          ></el-table-column>
          <el-table-column
            prop="stu_id"
            align="center"
            label="学号"
          ></el-table-column>
          <el-table-column
            prop="station"
            align="center"
            label="函授站点"
          ></el-table-column>
          <el-table-column
            prop="name"
            align="center"
            width='230px'
            label="课程"
          >
            <template slot-scope="scope">
              {{crsDataHash[scope.row.crs_id]}}
            </template>
          </el-table-column>
          <el-table-column
            prop="video_score"
            align="center"
            label="视频成绩"
          >
            <template slot-scope='scope'>

           
<div v-if='modify_flag'>
              <el-input
                 v-if="scope.row.crs_id!=''"
                :readonly='isbatchShow'
                @dblclick.native='dblclick()'
                  @focus='focus($event)'
                  @blur=' blur($event)'
              
                oninput="value=value.replace(/[^0-9]/g,'')"
                :max="100"
                v-model="scope.row.video_score"
                @change="SpBlur(scope.row)"
              ></el-input>
              </div>
  <div v-else> {{scope.row.video_score}}</div>

            </template>
          </el-table-column>
          <el-table-column
            prop="homework_score"
            align="center"
            label="作业成绩"
          >
            <template slot-scope='scope'>
<div v-if='modify_flag'>
              <el-input
                 v-if="scope.row.crs_id!=''"
                :readonly='isbatchShow'
                 @focus='focus($event)'
                  @blur=' blur($event)'
                oninput="value=value.replace(/[^0-9]/g,'')"
                :max="100"
                v-model="scope.row.homework_score"
                @change="ZyBlur(scope.row)"
                @dblclick.native='dblclick()'
              ></el-input>
       </div>
  <div v-else> {{scope.row.homework_score}}</div>
             
            </template>
          </el-table-column>
          <el-table-column
            prop="test_score"
            align="center"
            label="考试成绩"
          >
            <template slot-scope='scope'>

            <div v-if='modify_flag'>
                <el-input
                   v-if="scope.row.crs_id!=''"
                  :readonly='isbatchShow'
                  @dblclick.native='dblclick()'
                   @focus='focus($event)'
                  @blur=' blur($event)'
                  oninput="value=value.replace(/[^0-9]/g,'')"
                  :max="100"
                  v-model="scope.row.test_score"
                  @change="ErBlur(scope.row)"
                ></el-input>
       </div>
  <div v-else> {{scope.row.test_score}}</div>
          

            </template>
          </el-table-column>
          <el-table-column
            prop="total"
            align="center"
            label="总分"
          >
            <template slot-scope='scope'>
              <div :class="scope.row.total>=60?scope.row.total<=80?'color-green':'color-blue':'color-red'">
                {{scope.row.total}}
              </div>
            </template>
          </el-table-column>
          <!--                    <el-table-column label="操作" width="280px" align="center"  fixed="right">-->
          <!--                        <template slot-scope="scope">-->
          <!--                            <el-button-->
          <!--                                class="primary-btn"-->
          <!--                                @click="edit(scope.$index, scope.row)"-->
          <!--                            >成绩详情</el-button>-->
          <!--							<el-button-->
          <!--                                class="primary-btn"-->
          <!--                                @click="release(scope.row.id)"-->
          <!--								v-if="scope.row.state === 0"-->
          <!--								:disabled="org != accountOrg"-->
          <!--								style="margin-left: 16px"-->
          <!--                            >&nbsp;&nbsp;&nbsp;&nbsp;发布&nbsp;&nbsp;&nbsp;&nbsp;</el-button>-->
          <!--							<el-button-->
          <!--								@click="cancelRelease(scope.row.id)"-->
          <!--								type="danger"-->
          <!--								v-if="scope.row.state === 1"-->
          <!--								:disabled="org != accountOrg"-->
          <!--								style="margin-left: 16px"-->
          <!--							>取消发布</el-button>-->
          <!--                        </template>-->
          <!--                    </el-table-column>-->
        </el-table>
      </div>
      <div class="pagination">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :current-page=pageIndex
          :page-size=2
          :total=pageTotal
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>

    <!-- 编辑弹出框 -->
    <el-dialog
      title='成绩详情'
      :visible.sync="dialogVisible"
      width="800px"
      :close-on-click-modal='false'
      :close-on-press-escape='false'
    >
      <el-table
        :data="performanceData"
        class="table"
        border
        :cell-style="{color:'#666666',fontSize:'14px'}"
        :header-cell-style="{background:'#eef1f6',color:'#333333',height:'49px',fontWeight:500,fontSize:'14px'}"
      >
        <el-table-column
          prop="name"
          align="center"
          label="课程"
        >
          <template slot-scope="scope">
            {{crsDataHash[scope.row.crs_id]}}
          </template>
        </el-table-column>
        <el-table-column
          prop="video_score"
          align='center'
          label="视频成绩"
        >
        </el-table-column>
        <el-table-column
          prop="homework_score"
          align='center'
          label="作业成绩"
        >
        </el-table-column>
        <el-table-column
          prop="test_score"
          align="center"
          label="考试成绩"
        >
          <template slot-scope="scope">
            <el-input-number
              :controls="false"
              v-model="scope.row.test_score"
              controls-position="right"
              :min="0"
              :max="100"
              :disabled="org != accountOrg || scope.row.exam_type != 1"
            ></el-input-number>
          </template>
        </el-table-column>
        <el-table-column
          prop="total"
          align="center"
          label="总分"
        >
        </el-table-column>
      </el-table>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="cancel()">取 消</el-button>
        <el-button
          type="primary"
          @click="save()"
          style="margin-left: 16px"
          :disabled="org != accountOrg"
        >确 定</el-button>
      </span>
    </el-dialog>

    <!-- 批量修改学生成绩 -->
    <el-dialog
      title="批量修改学生成绩"
      :visible.sync="batchShow"
      width="50%"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >

        <div> 条件：</div>
        <el-form-item
          label="年级"
          prop="grade"
        >
          <el-date-picker
            v-model="ruleForm.grade"
            type="year"
            placeholder="请选择年级"
            format="yyyy"
            value-format="yyyy"
            style="width: 240px"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item
          label="学期"
          prop="semester_id"
        >
          <el-select
            class="search-input"
            filterable
            clearable
                  style="width: 240px"
            v-model="ruleForm.semester_id"
            placeholder="请选择学期"
          >
            <el-option
              v-for="item in semesters"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            > </el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          label="专业"
          prop="region"
        >
          <el-select
            v-model="ruleForm.major_id"
            filterable
                  style="width: 240px"
            clearable
            placeholder="请选择专业"
          >
            <el-option
              v-for="item in majorList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="函授站点">
          <el-select
            class="search-input"
            filterable
                  style="width: 240px"
            clearable
            v-model="ruleForm.station_id"
            placeholder="请选择函授站点"
          >
            <el-option
              v-for="item in stations"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            > </el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          label="视频成绩"
          prop="region"
        >

          <div class="df">

            <div :style="{'width':'150px'}">
              <el-select
                class="search-input"
                filterable
                clearable
                v-model="ruleForm.video_condition[0]"
                placeholder="请选择范围"
                @change="isVC(ruleForm.video_condition[0])"
              >
                <el-option
                  v-for="item in homeworks"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                > </el-option>
              </el-select>
            </div>

            <div class="df1">

              <el-input-number
                v-model="ruleForm.video_condition[1]"
                :min="isVMin"
                :max="isVMax"
                :disabled="isVD"
                @change="isVCdata1(ruleForm.video_condition[1])"
                label="描述文字"
              ></el-input-number>

              <div class="lien">至</div>

              <el-input-number
                v-model="ruleForm.video_condition[2]"
                :min="isVMin2"
                :max="isVMax2"
                :disabled="isVD2"
                label="描述文字"
              ></el-input-number>

            </div>

          </div>

        </el-form-item>

        <el-form-item
          label="作业成绩"
          prop="region"
        >

          <div class="df">

            <div :style="{'width':'150px'}">
              <el-select
                class="search-input"
                filterable
                clearable
                @change="isZC(ruleForm.homework_condition[0])"
                v-model="ruleForm.homework_condition[0]"
                placeholder="请选择范围"
              >
                <el-option
                  v-for="item in tests"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                > </el-option>
              </el-select>
            </div>

            <div class="df1">
              <el-input-number
                v-model="ruleForm.homework_condition[1]"
                :min="isZMin"
                :max="isZMax"
                :disabled="isZD"
                @change="isZCdata1(ruleForm.homework_condition[1])"
                label="描述文字"
              ></el-input-number>
              <div class="lien">至</div>
              <el-input-number
                v-model="ruleForm.homework_condition[2]"
                :min="isZMin2"
                :max="isZMax2"
                :disabled="isZD2"
                label="描述文字"
              ></el-input-number>
            </div>

          </div>

        </el-form-item>

        <el-form-item
          label="考试成绩"
          prop="region"
        >

          <div class="df">

            <div :style="{'width':'150px'}">
              <el-select
                class="search-input"
                filterable
                clearable
                @change="isKC(ruleForm.test_condition[0])"
                v-model="ruleForm.test_condition[0]"
                placeholder="请选择范围"
              >
                <el-option
                  v-for="item in tests"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                > </el-option>
              </el-select>
            </div>

            <div class="df1">
              <el-input-number
                v-model="ruleForm.test_condition[1]"
                :min="isKMin"
                :max="isKMax"
                :disabled="isKD"
                @change="isKCdata1(ruleForm.test_condition[1])"
                label="描述文字"
              ></el-input-number>
              <div class="lien">至</div>
              <el-input-number
                v-model="ruleForm.test_condition[2]"
                :min="isKMin2"
                :max="isKMax2"
                :disabled="isKD2"
                label="描述文字"
              ></el-input-number>
            </div>

          </div>

        </el-form-item>
        <el-divider></el-divider>

        <div :style="{'margin':'20px 0'}"> 修改后成绩范围：</div>

        <el-form-item
          label="视频成绩"
          prop="region"
        >

          <div class="df2">
            <el-input-number
              v-model="ruleForm.video_scores[0]"
              :min="VMin"
              :max="VMax"
              @change="Vchange(ruleForm.video_scores[0])"
              label="描述文字"
              :disabled="VIMin"
            ></el-input-number>
            <div class="lien">至</div>
            <el-input-number
              v-model="ruleForm.video_scores[1]"
              :min="VMin2"
              :max="VMax2"
              label="描述文字"
              :disabled="VIMax"
            ></el-input-number>
          </div>
        </el-form-item>

        <el-form-item
          label="作业成绩"
          prop="region"
        >

          <div class="df2">
            <el-input-number
              v-model="ruleForm.homework_scores[0]"
              :min="ZMin"
              :max="ZMax"
              :disabled="ZIMin"
              @change="Zchange(ruleForm.homework_scores[0])"
              label="描述文字"
            ></el-input-number>
            <div class="lien">至</div>
            <el-input-number
              v-model="ruleForm.homework_scores[1]"
              :min="ZMin2"
              :max="ZMax2"
              :disabled="ZIMax"
              label="描述文字"
            ></el-input-number>
          </div>
        </el-form-item>

        <el-form-item
          label="考试成绩"
          prop="region"
        >

          <div class="df2">
            <el-input-number
              v-model="ruleForm.test_scores[0]"
              :min="KMin"
              :max="KMax"
              :disabled="KIMin"
              @change="Kchange(ruleForm.test_scores[0])"
              label="描述文字"
            ></el-input-number>
            <div class="lien">至</div>
            <el-input-number
              v-model="ruleForm.test_scores[1]"
              :min="KMin2"
              :max="KMax2"
              :disabled="KIMax"
              label="描述文字"
            ></el-input-number>
          </div>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            @click="submitForm('ruleForm')"
          >确定</el-button>
          <el-button @click="batchShow=false">取消</el-button>
        </el-form-item>
      </el-form>

    </el-dialog>

  </div>
</template>

<script>
import { isBlank } from '../../utils/util';
export default {
    name: 'Result',
    data() {
        return {



              modify_flag:false,
            stations: [],
            stationsHash: [],
            searchData: '',
            station: '',
            detailData: [],
            performanceData: [],
            dialogVisible: false,
            pageIndex: 1,
            pageSize: 10,
            pageTotal: 0,
            tableData: [],
            content: '',
            grade: 0,
            major_id: 0,
            semester: 0,
            org: 0,
            phone: 0,
            semester_id: 0,
            majorName: '',
            crsDataHash: [],
            crsData: [],
            previewData: [],
            accountOrg: 0,

            /************************************* */
            isVMin: 0,
            isVMax: 100,
            isVD: true,

            isVMin2: 0,
            isVMax2: 100,
            isVD2: true,

            isZMin: 0,
            isZMax: 100,
            isZD: true,

            isZMin2: 0,
            isZMax2: 100,
            isZD2: true,

            isKMin: 0,
            isKMax: 100,
            isKD: true,

            isKMin2: 0,
            isKMax2: 100,
            isKD2: true,

            /*结果 */

            VMin: 0,
            VMax: 100,
            VMin2: 0,
            VMax2: 100,

            VIMin: true,
            VIMax: true,

            ZMin: 0,
            ZMax: 100,
            ZMin2: 0,
            ZMax2: 100,

            ZIMin: true,
            ZIMax: true,

            KMin: 0,
            KMax: 100,
            KMin2: 0,
            KMax2: 100,

            KIMin: true,
            KIMax: true,

            semesters: [
                {
                    value: '1',
                    label: '第一学期'
                },
                {
                    value: '2',
                    label: '第二学期'
                },
                {
                    value: '3',
                    label: '第三学期'
                },
                {
                    value: '4',
                    label: '第四学期'
                },
                {
                    value: '5',
                    label: '第五学期'
                },
                {
                    value: '6',
                    label: '第六学期'
                }
            ], //学期
            majorList: [], //专业下拉

            stations: [], //函授站点

            //视频城建条件
            videos: [
                {
                    value: '大于等于',
                    label: '大于等于'
                },
                {
                    value: '介于',
                    label: '介于'
                },
                {
                    value: '小于等于',
                    label: '小于等于'
                }
            ],
            //作业城建条件
            homeworks: [
                {
                    value: '大于等于',
                    label: '大于等于'
                },
                {
                    value: '介于',
                    label: '介于'
                },
                {
                    value: '小于等于',
                    label: '小于等于'
                }
            ],
            //考试城建条件
            tests: [
                {
                    value: '大于等于',
                    label: '大于等于'
                },
                {
                    value: '介于',
                    label: '介于'
                },
                {
                    value: '小于等于',
                    label: '小于等于'
                }
            ],

            isbatchShow: true,
            batchShow: false,
            ruleForm: {
                grade: '', //年级
                semester_id: '', //学期
                major_id: '', //专业
                station_id: '', //函授站

                video_condition: ['', 0, 0], //条件-视频成绩
                homework_condition: ['', 0, 0], //条件-作业成绩
                test_condition: ['', 0, 0], //条件-考试成绩

                video_scores: [], //视频成绩
                homework_scores: [], //作业成绩
                test_scores: [] //考试成绩
            },
            rules: {
                grade: [{ required: true, message: '请选择活动区域', trigger: 'change' }],
                semester_id: [{ required: true, message: '请选择活动区域', trigger: 'change' }],
                major_id: [{ required: true, message: '请选择活动区域', trigger: 'change' }],
                station_id: [{ required: true, message: '请选择活动区域', trigger: 'change' }]
            }
        };
    },

    created() {



               
        var modify_flagbef=localStorage.getItem('modify_flag');
        if(modify_flagbef=='true'){
         this.modify_flag=true

        }else{
            this.modify_flag=false 
        }
        this.accountOrg = localStorage.getItem('org');
        this.grade = this.$route.query.grade;
        this.major_id = this.$route.query.major_id;
        this.semester = this.$route.query.semester;
        this.org = this.$route.query.org;
        this.semester_id = this.$route.query.semester_id;
        this.majorName = this.$route.query.majorName;
        this.semesterName = this.$route.query.semesterName;
        this.getData();
        this.getCrsData();
        this.getTblInfo();
    },
    watch: {
        $route() {
            this.grade = this.$route.query.grade;
            this.major_id = this.$route.query.major_id;
            this.semester = this.$route.query.semester;
            this.org = this.$route.query.org;
            this.semester_id = this.$route.query.semester_id;
            this.majorName = this.$route.query.majorName;
            this.semesterName = this.$route.query.semesterName;
            this.getData();
        }
    },
    mounted() {
        this.initData();
    },
    methods: {
        showProgress() {
            this.$router.push({ path: '/task' });
        },
        save() {
            this.performanceData.forEach((item, index) => {
                item.semester_id = this.semester_id;
                item.phone = this.phone;
            });
            if (this.performanceData.length <= 0) {
                this.dialogVisible = false;
                return;
            }
            let parameter = { crs_list: this.performanceData };
            this.$put(this.BASEURL + `/achievement/stuachievementdetail`, parameter).then((res) => {
                if (res.code === 200) {
                    this.$message.success('保存成功!');
                    this.getData();
                    this.dialogVisible = false;
                } else {
                    console.log(res.error);
                }
            });
        },
        edit(index, data) {
            this.detailData = data;
            this.phone = data.phone;
            this.getStudentData();
            this.dialogVisible = true;
        },
        cancel() {
            this.dialogVisible = false;
        },
        reset() {
            this.searchData = '';
            this.station = '';
            this.getData();
        },
        exportStuScore() {
            this.$post(this.BASEURL + '/achievement/export/stu/score', {
                grade: this.grade,
                major_id: this.major_id,
                semester_id: this.semester_id,
                semesterName: this.semesterName
            }).then((res) => {
                if (res.code === 200) {
                    this.$message.success(res.msg);
                    // window.open(res.file_url)
                } else {
                    this.$message.error(res.error);
                }
            });
        },
        getTblInfo() {
            this.$post(this.BASEURL + '/assets/table/info', {
                tbl_list: [['id', 'name', 'station_base_t']],
                state: 1
            }).then((res) => {
                if (res.code === 200) {
                    this.stations = res.data[0][0];
                    this.stationsHash = res.data[0][1];
                } else {
                    console.log(res.error);
                }
            });
        },
    

        getStudentData() {
            this.$get(
                this.BASEURL + `/achievement/stuachievementdetail?semester_id=${this.semester_id}&phone=${this.detailData.phone}`
            ).then((res) => {
                if (res.code === 200) {
                    this.performanceData = res.data;
                } else {
                    console.log(res.error);
                }
            });
        },
        getCrsData() {
            this.$get(this.BASEURL + '/tution/course/GET').then((res) => {
                if (res.code === 200) {
                    this.crsData = res.crsData;
                    let hash = [];
                    this.crsData.forEach((item, index) => {
                        hash[item.id] = item.name;
                    });
                    this.crsDataHash = hash;
                } else {
                    console.log(res.error);
                }
            });
        },
        release(id) {
            if (isBlank(id)) {
                this.$message.error('未查找到当前学生的学期信息,请联系管理员。');
                return;
            }

            let parameter = { semester_id: this.semester_id, id: id, state: 1 };

            this.$put(this.BASEURL + `/achievement/release`, parameter).then((res) => {
                if (res.code === 200) {
                    this.$message.success('发布成功!');
                    this.getData();
                } else {
                    console.log(res.error);
                }
            });
        },
        cancelRelease(id) {
            let parameter = { semester_id: this.semester_id, id: id, state: 0 };

            this.$put(this.BASEURL + `/achievement/release`, parameter).then((res) => {
                if (res.code === 200) {
                    this.$message.success('已取消发布!');
                    this.getData();
                } else {
                    console.log(res.error);
                }
            });
        },
        handlePageChange(val) {
            this.pageIndex = val;
            this.getData();
        },
        //表格合并
        spanMethod({ row, column, rowIndex, columnIndex }) {
            console.log(row.rows);
            if ([0, 1, 2, 3, 4].includes(columnIndex)) {
                if (row.rows > 0) {
                    return {
                        rowspan: row.rows,
                        colspan: 1
                    };
                } else if (row.rows == 0) {
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                } else {
                    return {
                        rowspan: 1,
                        colspan: 1
                    };
                }
            }
        },


/************************************************************************** */
    getData() {
            // this.$message.success('正在获取数据，请稍后。');
            this.$get(
                this.BASEURL +
                    `/achievement/stuachievementlist?page=${this.pageIndex}&grade=${this.grade}
			&major_id=${this.major_id}&semester_id=${this.semester_id}&org=${this.org}&content=${this.searchData}&station_id=${this.station}`
            ).then((res) => {
                if (res.code === 200) {
                    this.tableData = res.data;
                    this.pageTotal = res.total;

                    for (let i = 0; i < this.tableData.length; i++) {
                        this.tableData[i]['isShow'] = true;
                    }
                } else {
                    console.log(res.error);
                }
            });
        },
        //
        ErBlur(row) {
            console.log('失去焦点时触发');
            console.log(row);

            var pamas = {
                phone: row.phone,
                semester_id: this.semester_id,
                crs_id: row.crs_id,
                test_score: parseInt(row.test_score)
            };
            console.log(pamas);

            this.$post(this.BASEURL + '/achievement/modify/student/score', pamas).then((res) => {
                if (res.code === 200) {
                    this.$message.success(res.msg);
                   
                } else {
                    this.$message.error(res.error);
                }
                 this.getData();
            });
        },
        ZyBlur(row) {
            console.log('失去焦点时触发');
            console.log(row);

            var pamas = {
                phone: row.phone,
                semester_id: this.semester_id,
                crs_id: row.crs_id,
                homework_score: parseInt(row.homework_score)
            };
            console.log(pamas);

            this.$post(this.BASEURL + '/achievement/modify/student/score', pamas).then((res) => {
                if (res.code === 200) {
                    this.$message.success(res.msg);
                  
                } else {
                    this.$message.error(res.error);
                }
                  this.getData();
            });
        },
        SpBlur(row) {
            console.log('失去焦点时触发');
            console.log(row);

            var pamas = {
                phone: row.phone,
                semester_id: this.semester_id,
                crs_id: row.crs_id,
                video_score: parseInt(row.video_score)
            };

            this.$post(this.BASEURL + '/achievement/modify/student/score', pamas).then((res) => {
                if (res.code === 200) {
                    this.$message.success(res.msg);
                   
                } else {
                    this.$message.error(res.error);
                }
                 this.getData();
            });
        },
        ckV(row) {
            row.isShow = false;
        },

        /**批量修改学生成绩 */
        batch() {
            this.batchShow = true;
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.ruleForm.major_id = this.ruleForm.major_id == '' ? null : this.ruleForm.major_id;
                    this.ruleForm.station_id = this.ruleForm.station_id == '' ? null : this.ruleForm.station_id;

                    //    video_condition: ['', 0, 0], //条件-视频成绩
                    //     homework_condition: ['', 0, 0], //条件-作业成绩
                    //     test_condition: ['', 0, 0], //条件-考试成绩

                    this.ruleForm.video_scores = this.ruleForm.video_condition[0] == '' ? [] : this.ruleForm.video_scores;
                    this.ruleForm.homework_scores = this.ruleForm.homework_condition[0] == '' ? [] : this.ruleForm.homework_scores;
                    this.ruleForm.test_scores = this.ruleForm.test_condition[0] == '' ? [] : this.ruleForm.test_scores;

                    console.log('数据----》', this.ruleForm);

                    this.$post(this.BASEURL + '/achievement/batch/modify/score', this.ruleForm).then((res) => {
                        if (res.code === 200) {
                            this.batchShow = false;

                            setTimeout(() => {
                                this.getData();
                            }, 1000);

                            this.$message.success(res.msg);

                            //处理数据
                        } else {
                            this.$message.error(res.error);
                        }
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        dblclick() {


            console.log('双击');
            this.isbatchShow = false;

       
        },
    

        //批量数据初始化
        initData() {
            //1.年级

            //2.学期
            //3.专业
            this.getTblInfo3();
            //4.函授站点
            this.getTblInfo4();
        },
        getTblInfo3() {
            this.$post(this.BASEURL + '/assets/table/info', {
                tbl_list: [
                    ['id', 'grade,level,name', 'major_base_t'],
                    ['org', 'org_name', 'academy_base_t']
                ],
                state: 1
            }).then((res) => {
                if (res.code === 200) {
                    console.log('res.reeres.reeres.reeres.reeres.reeres.ree', res);
                    this.majorList = res.data[0][0];
                } else {
                    console.log(res.error);
                }
            });
        },
        getTblInfo4() {
            this.$post(this.BASEURL + '/assets/table/info', {
                tbl_list: [
                    ['org', 'org_name', 'academy_base_t'],
                    ['id', 'name', 'station_base_t']
                ],
                state: 1
            }).then((res) => {
                if (res.code === 200) {
                    this.stations = res.data[1][0];
                } else {
                    console.log(res.error);
                }
            });
        },

        /**视频 */
        isVC(val) {
            if (val == '大于等于' || val == '小于等于') {
                this.isVD = false;
                this.isVD2 = true;

                this.VIMin = false;
                this.VIMax = false;
            } else if (val == '') {
                (this.isVMin = 0), (this.isVMax = 100), (this.isVMin2 = 0), (this.isVMax2 = 100), (this.ruleForm.video_condition[1] = 0); //条件-视频成绩
                this.ruleForm.video_condition[2] = 0; //条件-视频成绩
                this.isVD = true;
                this.isVD2 = true;

                this.VIMin = true;
                this.VIMax = true;

                this.ruleForm.video_scores=[]; //视频成绩
              
            } else {
                this.isVD = false;
                this.isVD2 = false;

                this.VIMin = false;
                this.VIMax = false;
            }
        },
        isVCdata1(val) {
            this.isVMin2 = val;

            this.ruleForm.video_condition[2] = this.ruleForm.video_condition[1];
        },

        /**作业 */
        isZC(val) {
            if (val == '大于等于' || val == '小于等于') {
                this.isZD = false;
                this.isZD2 = true;

                this.ZIMin = false;
                this.ZIMax = false;
            } else if (val == '') {
                this.isZD = true;
                this.isZD2 = true;

                this.isZMin = 0,
                 this.isZMax = 100
                 this.isZMin2 = 0
                this.isZMax2 = 100
                   this.ruleForm.homework_condition[1] = 0; //条件-视频成绩
                this.ruleForm.homework_condition[2] = 0; //条件-视频成绩
                this.ZIMin = true;
                this.ZIMax = true;

                this.ruleForm.homework_scores=[] //条件-视频成绩
               
            } else {
                this.isZD = false;
                this.isZD2 = false;

                this.ZIMin = false;
                this.ZIMax = false;
            }
        },
        isZCdata1(val) {
            this.isZMin2 = val;

            this.ruleForm.homework_condition[2] = this.ruleForm.homework_condition[1];
        },

        /**考试 */
        isKC(val) {
            console.log(val);

            if (val == '大于等于' || val == '小于等于') {
                this.isKD = false;
                this.isKD2 = true;

                this.KIMin = false;
                this.KIMax = false;
            } else if (val == '') {
                this.isKD = true;
                this.isKD2 = true;
                (this.isKMin = 0), (this.isKMax = 100), (this.isKMin2 = 0), (this.isKMax2 = 100), (this.ruleForm.test_condition[1] = 0); //条件-视频成绩
                this.ruleForm.test_condition[2] = 0; //条件-视频成绩
                this.KIMin = true;
                this.KIMax = true;

                this.ruleForm.test_scores=[]; //条件-视频成绩
                
            } else {
                this.isKD = false;
                this.isKD2 = false;

                this.KIMin = false;
                this.KIMax = false;
            }
        },
        isKCdata1(val) {
            this.isKMin2 = val;

            this.ruleForm.test_condition[2] = this.ruleForm.test_condition[1];
        },

        /**结果 */

        // 视频
        Vchange(val) {
            this.VMin2 = val;
            this.ruleForm.video_scores[1] = 0;
        },

        //作业
        Zchange(val) {
            this.ZMin2 = val;
            this.ruleForm.homework_scores[1] = 0;
        },

        //考试
        Kchange(val) {
            this.KMin2 = val;
            this.ruleForm.test_scores[1] = 0;
        },
   focus(event) {
            console.log('获取焦点');
            console.log(event);
            let input = event.currentTarget;
            console.log(input);
            //   input.placeholder = "请输入" + val
            input.style.border = '2px solid #409EFF'; //#DCDFE6
        },

            blur(event) {
            this.isbatchShow = true;


             let input = event.currentTarget;
            console.log(input);
        
            input.style.border = '1px solid #DCDFE6'; //#
        },
    }
};
</script>

<style lang="scss" scoped>
.body {
    button {
        padding: 8px 15px;
        font-size: 14px;
    }
}

 

.search-box {
    background-color: #ffffff;
    display: flex;
    align-items: center;
    padding: 28px 30px;
    margin-top: $distance;
    margin-bottom: $distance;
    border-radius: $radius;
    .search-input {
        width: 240px;
    }
    .title {
        font-size: $title-size;
        line-height: 15px;
        color: #343434;
    }
}
.tab-box {
    display: flex;
    align-items: center;
    margin-bottom: 28px;
    .tab-warp {
        margin: 0 15px;
        &:first-of-type {
            margin: 0;
        }
        display: flex;
        align-items: center;
        .title {
            font-size: 14px;
            line-height: 32px;
            margin-right: 5px;
            color: #343434;
        }
        .tab {
            color: #666666;
            font-size: 14px;
            text-align: center;
            padding: 0 20px;
            height: 32px;
            line-height: 32px;
            background-color: #f5f7fa;
            border-radius: 5px;
        }
    }
}

 
.top {
    width: 100%;
}
.df {
    display: flex;
}
.df1 {
    display: flex;
    margin: 0 10px;
}
.df2 {
    display: flex;
}
.lien {
    margin: 0 10px;
}

.number {
    width: 150px;
}
.primary-btn {
    border-color: #409eff;
    color: #409eff;
}
/deep/.el-input-number__increase {
    display: none;
}
/deep/ .el-input-number__decrease {
    display: none;
}
 
</style>
